module.exports = __webpack_public_path__ + "static/media/lasso.60851f41.png";